export default __webpack_public_path__ + "ad0937c0b179762cdf7a869e39156340.png";